import { Unit } from "uom";
/**
 * The unit for plane angle quantities ( <code>rad</code> ).
 * One radian is the angle between two radii of a circle such that the length of the arc between them is equal to the radius.
 */
export var Radian = Unit.createBase("Radian", "Angle", "rad");
export var Degrees = Unit.timesNumber("Degrees", Math.PI / 180.0, Radian);
//# sourceMappingURL=angle.js.map